import { cn } from "@/lib/utils";

// Loading placeholders (same pulse as the Agent Finder list skeleton: bg-muted / bg-page blocks).
// Size every piece to the content it stands in for so the page does not jump when data arrives.

export function NvSkeleton({ className }: { className?: string }) {
  return <span aria-hidden className={cn("block animate-pulse rounded-nv-pill bg-nv-bg-muted", className)} />;
}

// Agent list card (110px), the card Agent Finder / My Page lists are made of
export function NvSkeletonCard({ className }: { className?: string }) {
  return (
    <div aria-hidden className={cn("flex h-[110px] gap-5 rounded-nv-card border border-nv-border bg-nv-surface p-6", className)}>
      <span className="h-14 w-14 shrink-0 animate-pulse rounded-nv-card bg-nv-bg-muted" />
      <span className="flex flex-1 flex-col gap-[10px] pt-[2px]">
        <span className="h-4 w-[220px] animate-pulse rounded-nv-pill bg-nv-bg-muted" />
        <span className="h-3 w-full animate-pulse rounded-nv-pill bg-nv-bg-page" />
        <span className="h-3 w-[420px] max-w-full animate-pulse rounded-nv-pill bg-nv-bg-page" />
      </span>
    </div>
  );
}
